var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Platform, ScrollView, Text, TextInput, View } from 'react-native';
import { ScreenLayout } from '@/components/ScreenLayout';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import useAppComponents from '@/hooks/useAppComponents';
import usePost from '@/hooks/usePost';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import { cn } from '@/utils/cn';
import ToastUtils from '@/utils/ToastUtils';
const AddCommentScreen = ({ navigation, route }) => {
    const { api } = useAppComponents();
    const { type, placeId, buildingId } = route.params;
    const id = buildingId !== null && buildingId !== void 0 ? buildingId : placeId;
    const [comment, setComment] = useState('');
    const queryClient = useQueryClient();
    const registerComment = usePost(['AddComment', type, id], (params) => __awaiter(void 0, void 0, void 0, function* () {
        if (params.type === 'place') {
            yield api.registerPlaceAccessibilityCommentPost({
                comment: params.comment,
                placeId: id,
            });
        }
        else {
            yield api.registerBuildingAccessibilityCommentPost({
                comment: params.comment,
                buildingId: id,
            });
        }
        // PlaceDetailScreen 전체 데이터 갱신
        queryClient.invalidateQueries({
            queryKey: ['PlaceDetailV2', placeId],
        });
        // PlaceDetailScreen 접근성 정보 갱신 (코멘트 즉시 표시)
        queryClient.invalidateQueries({
            queryKey: ['PlaceDetailV2', placeId, 'Accessibility'],
        });
        ToastUtils.show('의견이 등록되었습니다.');
        navigation.goBack();
    }));
    let logParams = {};
    if (type === 'place') {
        logParams = { place_id: placeId };
    }
    else {
        logParams = { building_id: buildingId };
    }
    return (_jsx(LogParamsProvider, { params: logParams, children: _jsxs(ScreenLayout, { isHeaderVisible: true, safeAreaEdges: ['bottom'], children: [_jsx(ScrollView, { className: "bg-white", contentContainerClassName: "px-[20px] pb-[20px]", children: _jsxs(View, { children: [_jsx(Text, { className: "mt-[18px] mb-[20px] font-pretendard-bold text-[24px] leading-[32px] text-black", children: "\uC758\uACAC\uCD94\uAC00" }), _jsxs(Text, { className: "font-pretendard-regular text-[16px] leading-[24px] text-black", children: ["\uB354 \uB3C4\uC6C0\uC774 \uB420 \uC815\uBCF4\uAC00 \uC788\uB2E4\uBA74 \uB0A8\uACA8\uC8FC\uC138\uC694!", _jsx(Text, { className: "font-pretendard-regular text-[16px] leading-[24px] text-gray-70", children: "(\uC120\uD0DD)" })] }), _jsx(View, { className: "mt-[20px] rounded-[20px] border-[1px] border-brand-50 px-[25px] py-[20px]", children: _jsx(TextInput, { multiline: true, className: cn('p-0 font-pretendard-regular text-[16px] leading-[24px] text-black', Platform.OS === 'android' && 'min-h-[50px]'), value: comment, maxLength: 100, placeholder: '예시) 후문에는 계단이 없어 편하게 갈 수 있습니다 (최대 100글자)', placeholderTextColor: color.gray50, onChangeText: text => setComment(text) }) }), _jsxs(Text, { className: "mt-[10px] mr-[4px] text-right font-pretendard-regular text-[14px] leading-[20px] text-gray-70", children: [comment.length, " / 100"] })] }) }), _jsx(SccButton, { style: { marginHorizontal: 20, marginBottom: 20 }, text: "\uB4F1\uB85D\uD558\uAE30", onPress: () => {
                        registerComment.mutate({ type, comment, id });
                    }, elementName: "add_comment_register" })] }) }));
};
export default AddCommentScreen;
